import { drupalSiteUrl } from "../config";
import { reportWarning, reportError } from "../bugReporting";
import * as util from "./util";

function logoutUser() {
	util.deleteCookies();
	window.location.assign(`${drupalSiteUrl}/online-classes`);
}

export function handleUnknownError(error) {
	if (error.response && error.response.status === 401) {
		reportWarning("unauthorized call, logging out", error);
		logoutUser();
	} else {
		// eslint-disable-next-line
		reportError(error);
		console.log(error);
	}
}



// WEBPACK FOOTER //
// ./src/lib/errorHandler.js